// 路由配置
import { Suspense, useEffect } from 'react';
import { Routes, Route, useLocation, useNavigate } from 'react-router-dom';
import { matchQuery } from '@lhb/func';
import { setStorage } from '@lhb/cache';
import Layout from '@/layout';
import NotFound from '@/common/components/NotFound';
import RouterControl from './router/control'; // 路由守卫
// import { Spin } from 'antd';
import CenterSpin from './common/components/business/CenterSpin';
import { routersConfig } from '@/router/router';
// 注释动画的原因是，不同页面跳转时，某些固定（fixed）元素出现闪烁，比如，不同的地图页都加了Loading组件时，因为使用的是React Router，是由于新旧页面同时存在于DOM树中导致的
// import { TransitionGroup, CSSTransition } from 'react-transition-group';
// import { config } from '@/common/qiankun/config';
import { onNavigate } from '@/common/document-event/on';
import { setValidTimeCookie } from './common/utils/ways';
import { useTenantCheckInfo } from 'src/common/hook/useTenantCheckInfo';
import { useMethods } from '@lhb/hook';
import { getHeader } from './common/request/utils';

const routeList = routersConfig(); // 不能在jsx内执行，需要在Main函数之前就调用，才能获取到正确的页面组件

const Main = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const path = window.location.pathname;

  const { getTenantCheckInfo } = useTenantCheckInfo({ immediate: false });

  useEffect(() => {
    const token = matchQuery(window.location.search, 'lcn_token');
    if (token) {
      setStorage('flowLoginToken', token);
      setValidTimeCookie('flow_token', token);
    }

    onNavigate(navigate);
    // eslint-disable-next-line react-hooks/exhaustive-deps

    methods.init();

  }, []);

  const methods = useMethods({

    init() {
      // 因为 Layout 初始化会调用 tenantCheck，所以这里就不需要执行了
      // methods.initGetTenantCheckInfo();
    },

    /** 检查是否有 token */
    async checkHasToken() {
      // 获取逻辑复用请求接口时的逻辑
      const config: any = await getHeader(1);
      return !!config.token;
    },

    /** 初始化立即获取一次当前租户的检查信息（含拓店模板） */
    async initGetTenantCheckInfo() {

      /** 以下页面不请求 */
      const ignoreRoute = ['/share/youth'];
      if (ignoreRoute.includes(path)) {
        return;
      }

      /** 保险方法，需要请求的路由才进行请求 */
      const needRequestRoute = [
        /\/expandstore\/?.*/,
        // /\/insight\/?.*/,
        // /\/iterate\/?.*/,
        // /\/sitemap\/?.*/,
        // /\/spotevaluation\/?.*/,
        // /\/standardstore\/?.*/,
        // /\/storemap\/?.*/,
      ];
      try {
        if (needRequestRoute.some((item) => item.test(path))) {
          // 有 token 才请求接口；防止某些页面不需要请求
          if (await methods.checkHasToken()) {
            getTenantCheckInfo(true);
          }
        }
      } catch (error) {
        console.log('error', error);
      }
    },
  });

  return (
    <RouterControl locationTo={location} routeList={routeList}>
      <Layout>
        {/* <Suspense fallback={<CenterSpin />}> */}
        <Suspense fallback={<></>}>
          {/* <TransitionGroup component={null}>
            <CSSTransition key={location.key} classNames='fade' timeout={300}> */}
          {/* https://juejin.cn/post/6844903922574819342#heading-7 */}
          <Routes location={location}>
            {routeList.map((item) => (
              <Route key={item.path} path={item.path} element={<item.component location={location} />}></Route>
            ))}
            {/* 匹配子应用 */}
            {/* <Route path={`${config.basename}/*`} element={null}></Route> */}
            {/* 根页面特殊处理，不需要提示页面丢失，显示加载中更合适 */}
            <Route path='/' element={<CenterSpin />}></Route>
            {/* 匹配找不到的路由 */}
            <Route path='*' element={<NotFound />}></Route>
          </Routes>
          {/* </CSSTransition>
          </TransitionGroup> */}
        </Suspense>
      </Layout>
    </RouterControl>
  );
};

export default Main;
